import React, { useState } from 'react';

import { Box, Button, H1, RadioGroup, Text, VStack } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { FlowLayout } from './FlowLayout';
import { useDistributionFlow } from './hooks';

import type { DisbursementMethod as DisbursementMethodType } from './data';

const DisbursementMethod: React.FC = () => {
  const navigate = useNavigate();
  const { nextStep } = useDistributionFlow();
  const [selectedMethod, setSelectedMethod] = useState<DisbursementMethodType | null>(null);

  const handleContinue = () => {
    if (nextStep) void navigate(`../${nextStep}`, { relative: 'path' });
  };

  return (
    <FlowLayout gap="space.500">
      <VStack css={{ gap: 'space.500' }}>
        <H1 variant="title400">How would you like to receive your distribution payment?</H1>
        <RadioGroup
          appearance="default"
          value={selectedMethod ?? undefined}
          onValueChange={value => setSelectedMethod(value as DisbursementMethodType)}
        >
          <RadioGroup.ItemContainer>
            <RadioGroup.Item id="ach" value="ACH" aria-label="Electronic transfer" />
            <RadioGroup.ItemLabel htmlFor="ach">Electronic transfer</RadioGroup.ItemLabel>
          </RadioGroup.ItemContainer>
          <Box css={{ pl: 'space.400', pb: 'space.200' }}>
            <Text color="text.weak" variant="text50">
              Usually arrives within 4-5 business days
            </Text>
          </Box>
          <RadioGroup.ItemContainer>
            <RadioGroup.Item id="check" value="CHECK" aria-label="Paper check" />
            <RadioGroup.ItemLabel htmlFor="check">Paper check</RadioGroup.ItemLabel>
          </RadioGroup.ItemContainer>
          <Box css={{ pl: 'space.400' }}>
            <Text color="text.weak" variant="text50">
              Usually arrives within 2 weeks
            </Text>
          </Box>
        </RadioGroup>
      </VStack>
      <Button
        variant="solidPrimary"
        css={{ width: 'fit-content' }}
        onClick={() => void handleContinue()}
        disabled={selectedMethod === null}
      >
        Continue
      </Button>
    </FlowLayout>
  );
};

export default DisbursementMethod;
